import { Component, OnChanges, ChangeDetectionStrategy, input } from '@angular/core';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import {SureFlowRatingUnitResponse} from '../../model/sure-flow-rating-unit-response';
import {SureFlowPerformanceCoilOutputComponent} from '../sure-flow-performance-coil-output/sure-flow-performance-coil-output.component';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-sure-flow-performance-output',
    templateUrl: './sure-flow-performance-output.component.html',
    styleUrls: ['./sure-flow-performance-output.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SureFlowPerformanceCoilOutputComponent, DecimalPipe]
})
export class SureFlowPerformanceOutputComponent implements OnChanges {

  readonly response = input.required<SureFlowRatingUnitResponse>();
  readonly isMetric = input.required<boolean>();

  constructor() {
  }

  ngOnChanges() {
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.isMetric());
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.isMetric());
  }

  getLengthUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.isMetric());
  }

}
